import * as Sentry from '@sentry/react';

export const logErrorAndReport = ({
  error,
  isReportable = true,
}: {
  error: unknown;
  isReportable?: boolean;
}): void => {
  console.error(error);

  if (!isReportable) {
    return;
  }

  let reportableError: Error | null = null;

  if (typeof error === 'string') {
    reportableError = new Error(error);
  } else if (error instanceof Error) {
    reportableError = error;
  }

  if (reportableError) {
    Sentry.captureException(reportableError);
  }
};
